// Store the element that triggered the search for focus restoration
let $searchTrigger;

$('.js-search-icon').on('click keypress', function(e) {
    if (e.type === 'keypress' && e.which !== 13) return;
    e.preventDefault();
    $searchTrigger = $(this); // Store the trigger element
    openSearch();
});

$('.js-close-icon').on('click keypress', function(e) {
    if (e.type === 'keypress' && e.which !== 13) return;
    e.preventDefault();
    closeSearch();
});

function openSearch() {
    $('.search-icon').addClass('is-active');
    $('.nav-search').addClass('is-open');
    
    // get the width of all .nav-item elements combined
    $navItems = $('.site-header .nav-item');
    let $navItemsWidth = 0;
    $navItems.each(function() { 
        $navItemsWidth += $(this).width();
    });
    $('.nav-search.is-open').css('width', $navItemsWidth-40);
    
    // Hide navigation items
    $('.site-header .nav-item').addClass('is-hidden');
    
    // Focus the search input after opening
    setTimeout(function() {
        $('.nav-search input').focus();
    }, 100);
    
    // Set up focus trap
    setupFocusTrap();
}

function closeSearch() {
    $('.nav-search.is-open').css('width', '0');
    $('.search-icon').removeClass('is-active');
    $('.nav-search').removeClass('is-open');
    
    // Show navigation items
    $('.site-header .nav-item').removeClass('is-hidden');
    
    // Return focus to search trigger
    if ($searchTrigger && $searchTrigger.length) {
        $searchTrigger.focus();
    }
    
    // Remove focus trap
    removeFocusTrap();
}

// Focus trap functionality
function setupFocusTrap() {
    // Get all focusable elements within search form
    const $searchForm = $('.nav-search');
    const $focusableElements = $searchForm.find('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
    const $firstFocusableElement = $focusableElements.first();
    const $lastFocusableElement = $focusableElements.last();
    
    // Add keydown event listener to trap focus
    $searchForm.on('keydown.focusTrap', function(e) {
        // If Tab key is pressed
        if (e.key === 'Tab') {
            // If Shift+Tab on first element, move to last element
            if (e.shiftKey && document.activeElement === $firstFocusableElement[0]) {
                e.preventDefault();
                $lastFocusableElement.focus();
            } 
            // If Tab on last element, move to first element
            else if (!e.shiftKey && document.activeElement === $lastFocusableElement[0]) {
                e.preventDefault();
                $firstFocusableElement.focus();
            }
        }
    });
}

function removeFocusTrap() {
    $('.nav-search').off('keydown.focusTrap');
}

// Close search on escape key and return focus to trigger
$(document).on('keyup', function(e) {
    if (e.key === 'Escape' && $('.nav-search').hasClass('is-open')) {
        closeSearch();
    }
});

if ($(window).width() <= 991) {
    
    $('header .dropdown-toggle').on('click', function() {
        if($(window).width() <= 991) {
            $('.dropdown-menu').removeClass('show');
            $('body').addClass('no-scroll');
        }
    });
    // Disable sub nav when close icon is clicked
    $('.mobile-close').on('click', function() {
        if($(window).width() <= 991) {
            if($('body').hasClass('no-scroll')) {
                $('body').removeClass('no-scroll');
                $('.dropdown-menu').removeClass('show');
                $('.has-sub').removeClass('show');
            } else {
                $('body').addClass('no-scroll');
            }
        }
    });

    $('.js-overlay-back').on('click', function() {
        if($(window).width() <= 991) {
            $('.dropdown-menu').removeClass('show');
            $('.has-sub').removeClass('show');
        }
    });
}

var myCollapsible = document.getElementById('primaryNav')
// myCollapsible.addEventListener('hidden.bs.dropdown', function () {
//     $('.shadow-overlay').addClass('hide');
// });

myCollapsible.addEventListener('show.bs.dropdown', function () {
    $('.auth-menu>.nav-link').removeClass('show').attr('aria-expanded', 'false');
    $('.auth-menu>.dropdown-menu').removeClass('show').attr('aria-hidden', 'true');
});

$(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
        $('.main-nav .has-sub').each(function() {
            if($(this).hasClass('show')) {
                $(this).removeClass('nav-shadow');
                $(this).removeClass('show');
                $(this).next('.dropdown-menu').removeClass('show');    
            }
        });
   }
});

// Prevent dropdown from closing when clicking outside of anchor
$('.dropdown-menu').on('click', function(e) {
    e.stopPropagation();
});

// Set initial tabindex for dropdown items
$(document).ready(function() {
    // Set all dropdown menu items to tabindex="-1" initially
    $('.dropdown-menu a, .dropdown-menu button').attr('tabindex', '-1');
});

// Update dropdown toggle event handlers
$('.has-sub').on('show.bs.dropdown', function() {
    // When dropdown opens, make items focusable
    $(this).siblings('.dropdown-menu').find('a, button').attr('tabindex', '0');
});

$('.has-sub').on('hidden.bs.dropdown', function() {
    // When dropdown closes, make items unfocusable again
    $(this).siblings('.dropdown-menu').find('a, button').attr('tabindex', '-1');
});

// Ensure keyboard navigation works properly
$('.has-sub > .nav-link').on('keydown', function(e) {
    // Open dropdown on Enter or Space
    if ((e.key === 'Enter' || e.key === ' ') && !$(this).parent().hasClass('show')) {
        e.preventDefault();
        $(this).dropdown('toggle');
    }
});

// Handle Escape key for dropdowns (in addition to your existing Escape handler)
$('.dropdown-menu').on('keydown', function(e) {
    if (e.key === 'Escape') {
        e.preventDefault();
        $(this).closest('.has-sub').find('.nav-link').focus();
        $(this).closest('.has-sub').removeClass('show');
        $(this).removeClass('show');
    }
});
